enum ContactLifeCycleRoutes {
  List = '/contactlifecycle',
  Edit = '/contactlifecycle/edit/:id',
  Add = '/contactlifecycle/add',
}

export default ContactLifeCycleRoutes
